/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/302-loop': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M2 5h10v3l4-4-4-4v3H0v6h2zm12 6H4V8l-4 4 4 4v-3h12V7h-2z"/>'
  }
})
